import React from "react";
import Navbar from "../../components/Header/Navbar.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import Hero from "../../components/Hero.jsx";
import VideoSection from "../../components/VideoSection.jsx";
import ChallengeSection from "../../components/ChallengeSection.jsx";
import InsightsSection from "../../components/InsightsSection.jsx";
import IntelligenceSection from "../../components/IntelligenceSection.jsx";
import ApproachSection from "../../components/ApproachSection.jsx";
import MarketSection from "../../components/MarketSection.jsx";


const HomePage = () => {
  return <div>
    <Navbar />
    <Hero/>
    <VideoSection />
    <ChallengeSection />
    <InsightsSection />
    <IntelligenceSection />
    <ApproachSection />
    <MarketSection />




    <Footer />
  </div>;
};

export default HomePage;
